/* eslint-disable @typescript-eslint/no-explicit-any -- existing annotations; retyping would change compile behavior */
import { useState, useEffect } from 'react';
import { Autocomplete, TextField } from '@mui/material';
import { useLocation } from 'react-router-dom';
import ReactGA from 'react-ga4';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import * as S from './Forms.styled';

interface Props {
    data: any[];
    i: number;
    countries: string[];
    handleUpdate: (index: number, field: string, value: string | null) => void;
    validationMsg: any[];
}

function CountryAutocomplete({ data, i, countries, handleUpdate, validationMsg }: Props) {
    const { language_setting: language } = useSelector((state: RootState) => state.user.entity);
    const { t } = useTranslation();
    const location = useLocation();
    const [startTime, setStartTime] = useState(0);

    useEffect(() => {
        // Set up event listeners to track time spent on field
        const input = document.querySelector<HTMLInputElement>(`#country`);
        input?.addEventListener('focus', () => setStartTime(Date.now()));
        input?.addEventListener('blur', () => {
            const endTime = Date.now();
            const elapsedTime = endTime - startTime;
            ReactGA.event({
                category: 'Form Field',
                action: 'Time Spent',
                label: `Country - ${location.pathname}`,
                value: elapsedTime,
            });
        });

        // Clean up event listeners when component unmounts
        return () => {
            input?.removeEventListener('focus', () => setStartTime(Date.now()));
            input?.removeEventListener('blur', () => {
                const endTime = Date.now();
                const elapsedTime = endTime - startTime;
                ReactGA.event({
                    category: 'Form Field',
                    action: 'Time Spent',
                    label: `Country - ${location.pathname}`,
                    value: elapsedTime,
                });
            });
        };
    }, [location.pathname, startTime]);

    return (
        <S.FlexColumn>
            <Autocomplete
                disablePortal
                id="country"
                value={data[i].country}
                options={countries}
                onChange={(_, value: string | null) => {
                    handleUpdate(i, 'country', value);
                }}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label={`*${t('country', { lng: language })}`}
                        error={Boolean(validationMsg[i].country)}
                    />
                )}
            />
            <S.ValidationMsg>{validationMsg[i].country}</S.ValidationMsg>
        </S.FlexColumn>
    );
}

export default CountryAutocomplete;
